export default function isMetaFieldValueEmpty(value: unknown) {
  if (value === null || value === undefined) return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && Object.keys(value).length === 0) return true;
  if (typeof value === "string" && value.length === 0) return true;
  if (typeof value === "number" && value === 0) return true;

  return false;
}
